[
    '.product-mini',
].forEach(el => {
    [
        ...document.querySelectorAll(el)
    ].forEach(buttonParent => {
        const button = buttonParent.querySelector('.js-arrow-button');
        if (button) {
            buttonParent.addEventListener('mouseenter', () => {
                button.classList.add('animate');
            });
            buttonParent.addEventListener('mouseleave', () => {
                button.classList.remove('animate');
            });
        }
    });
});